import editorialStyle from "../../../components/editorial/style.scss";

import { Fragment } from "preact";
import Link, {
  Button,
  ButtonDualGroup,
  ButtonGroup,
  ButtonList,
  ButtonBar,
  LargeViewOnly,
  StickyButtons,
  affiliateMerchants,
} from "../../../components/link";
import AffiliateDisclosure from "../../../components/affiliate-disclosure";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import FixedTable from "../../../components/fixed-table";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import Tags from "../../../components/tags";
import ImageSet from "../../../components/image-set";
import Image from "../../../components/image";
import Author from "../../../components/author";
import EcoFlowCouponCode from "../components/coupon-code";
import NoWrap from "../../../components/no-wrap";
import SlugHeading from "../../../components/slug-heading";
import SlugLink from "../../../components/slug-link";
import Accordion from "../../../components/accordion";
import AccordionPreview from "../../../components/accordion/preview";
import PhotoListItem from "../../../components/photo-list-item";
import ReviewItem from "../../../components/review-item";
import Questions from "../../../components/questions";
import namedRoutes from "../../../settings/routes";
import { mergeClasses } from "../../../components/helpers";
import { lookupByUrl } from "../../../settings/route-data-lookup";

import AffiliateAd from "../../../components/affiliate-ad";

let headerInfo = lookupByUrl(namedRoutes.ecoflow.d3maxPlus);

const primedayLinks = false;
let productLinkData = {
  delta3MaxPlus: {
    affiliateData: affiliateMerchants.ecoflow,
    href: "https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441&view=d3m",
  },
  delta3Max: {
    affiliateData: affiliateMerchants.ecoflow,
    href: "https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873&view=d3m",
  },
  delta3UltraPlus: {
    affiliateData: affiliateMerchants.ecoflow,
    href: "https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713&view=d3u",
  },
};

if (primedayLinks) {
  productLinkData = {
    delta3MaxPlus: {
      affiliate: "https://bit.ly/43BdPLL",
      href: "https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441&view=d3m",
    },
    delta3Max: {
      affiliate: "https://bit.ly/3Q3P7Ab",
      href: "https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873&view=d3m",
    },
    delta3UltraPlus: {
      affiliate: "https://bit.ly/43dDPfZ",
      href: "https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713&view=d3u",
    },
  };
}

const Page = () => (
  <div>
    <Head data={headerInfo} />
    <Hero
      positionX={0}
      positionY={50}
      background="/images/products/ecoflow/delta-3-max-plus/battery_protection.webp"
      titlePrefix="EcoFlow"
      title="DELTA 3 Max Plus"
      subTitle="Vanlife Power Station Review"
    />
    <Editorial>
      <Center>
        <Author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />

        <LargeViewOnly>
          <ButtonList size="medium">
            <Button
              size="medium"
              {...productLinkData.delta3MaxPlus}
              icon="EcoFlow"
            >
              View on EcoFlow
            </Button>
            <Button
              size="medium"
              affiliate="https://amzn.to/4qhlyYI"
              href="https://www.amazon.com/dp/B0FQV9Q9J2/"
              secondary
              icon="Amazon"
            >
              View on Amazon
            </Button>
          </ButtonList>
        </LargeViewOnly>

        <p>
          The <strong>EcoFlow DELTA 3 Max Plus</strong> is a highly capable
          mid-sized power station that serves as a plug-and-play alternative to
          a complex DIY electrical system, saving days of installation time and
          thousands of dollars in component costs. It offers a significant
          performance jump over the base <strong>DELTA 3 Max</strong> by adding
          a robust 3,000W inverter, expansion battery support, native 30A DC
          output, and more, while remaining a lighter, more space-conscious, and
          budget-friendly alternative to its larger siblings, the{" "}
          <strong>DELTA 3 Ultra Plus</strong> and <strong>DELTA Pro 3</strong>.
        </p>

        <AffiliateDisclosure />

        <ImageSet
          size={4}
          border={true}
          images={[
            {
              lg: "/images/products/ecoflow/delta-3-max-plus/front.webp",
              alt: "DELTA 3 Max Plus: front",
            },
            {
              lg: "/images/products/ecoflow/delta-3-max-plus/back.webp",
              alt: "DELTA 3 Max Plus: back",
            },
            {
              lg: "/images/products/ecoflow/delta-3-max-plus/front-right.webp",
              alt: "DELTA 3 Max Plus: front right",
            },
            {
              lg: "/images/products/ecoflow/delta-3-max-plus/right.webp",
              alt: "DELTA 3 Max Plus: right",
            },
          ]}
        />

        <Accordion
          items={[
            {
              heading: "Table of Contents",
              content: (
                <ol>
                  <li>
                    <SlugLink>System Examples</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Highlights</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Considerations</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Detailed Comparison</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Full Specifications</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>DELTA 3 Max Series Comparison</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Accessories</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>DC Fuse Panel</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Alternator Chargers</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Solar Panels</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Extra Batteries</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Other Accessories</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Suggestions to EcoFlow</SlugLink>
                  </li>
                  <li>
                    <SlugLink>My Verdict</SlugLink>
                  </li>
                </ol>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">System Examples</SlugHeading>
        <ImageSet
          firstRowSize={2}
          size={3}
          images={[
            {
              lg: "/images/diagrams/power-systems/ecoflow/ecoflow-delta-3-max-plus.webp?v=3",
              alt: "EcoFlow DELTA 3 Max Plus vanlife system diagram: 800W alternator charger & an expansion battery",
            },
            {
              lg: "/images/diagrams/power-systems/ecoflow/ecoflow-delta-3-max-plus_alt-500+2-bat.webp?v=3",
              alt: "EcoFlow DELTA 3 Max Plus vanlife system diagram: 500W alternator charger & two expansion batteries",
            },
            {
              lg: "/images/diagrams/power-systems/ecoflow/ecoflow-delta-3-max-plus_alt-500.webp?v=3",
              alt: "EcoFlow DELTA 3 Max Plus vanlife system diagram: 800W alternator charger",
            },
            {
              lg: "/images/diagrams/power-systems/ecoflow/ecoflow-delta-3-max-plus_alt-500+1-bat.webp?v=3",
              alt: "EcoFlow DELTA 3 Max Plus vanlife system diagram: 500W alternator charger & an expansion battery",
            },
            {
              lg: "/images/diagrams/power-systems/ecoflow/ecoflow-delta-3-max-plus_2-bat.webp?v=3",
              alt: "EcoFlow DELTA 3 Max Plus vanlife system diagram: two expansion batteries",
            },
          ]}
        />

        <p class="caption">
          See below for a detailed look at expansion battery options and
          alternator charging requirements.
        </p>
      </Center>
      <Center>
        <SlugHeading tag="h2">Highlights</SlugHeading>
        <ul>
          <li>
            <strong>Great value:</strong> Packs heavy-duty specs at a much lower
            price point than the DELTA Pro 3 or DELTA 3 Ultra Plus.
          </li>
          <li>
            <strong>Compact size:</strong> Weighs in at a manageable sub-50 lbs
            (22.1 kg) with handles on both sides, making it easy to slide under
            a bench or bed platform.
          </li>
          <li>
            <strong>Dual solar input ports:</strong> Features two independent
            solar inputs (500W each / 1,000W max total). This provides the
            flexibility to support mismatched solar panels/arrays, deploy ground
            panels alongside a fixed roof array, or hook up a{" "}
            <Link href={namedRoutes.alternatorChargers}>
              third-party alternator charger
            </Link>
            .
          </li>
          <li>
            <strong>High AC output:</strong> Provides a robust 3,000W total
            continuous output (with a 6,000W surge capacity), easily running
            heavy loads like induction cooktops, water heaters, or microwaves.
          </li>
          <li>
            <strong>Independently switched AC groups:</strong> The four
            front-facing AC outlets are split into two groups that can be
            toggled on or off independently. This gives you granular control
            over what's running directly via the front buttons or the EcoFlow
            app. You can even use the app's Smart Output Priority to
            automatically shed non-essential loads (like chargers) while keeping
            critical circuits running when the battery gets low.
          </li>
          <li>
            <strong>Dedicated 30A DC output:</strong> Delivers a native
            12.6V⎓30A (378W max) via an Anderson Powerpole port to easily run a
            diesel heater and full 12V fuse block. This is EcoFlow’s smallest
            power station with a high-amp 12V output, moving past typical 10A
            cigarette socket limits.
          </li>
          <li>
            <strong>Expandable capacity:</strong> Scalable from its native
            2,048Wh capacity up to an impressive 10kWh by adding EcoFlow
            expansion batteries.
          </li>
          <li>
            <strong>Upgraded USB-C ports:</strong> Outfitted with 4x
            front-facing USB ports, including a high-output 140W USB-C PD port
            alongside two 45W USB-C ports and an 18W USB-A port.
          </li>
          <li>
            <strong>Strategic port layout:</strong> Main AC outlets and USB
            ports are on the front, while solar, battery expansion, and DC
            connections sit cleanly on the back. The rear ports feature
            ingenious hinged covers that slide inside the housing when open,
            keeping your setup tidy.
          </li>
          <li>
            <strong>Grid bypass mode:</strong> Routes AC shore power directly to
            your electronics. By skipping the internal battery, it prevents
            unnecessary wear while you are plugged in.
          </li>
          <li>
            <strong>Desktop-grade UPS performance:</strong> Ultra-fast sub-10ms
            automatic switching speed to keep sensitive electronics or mobile
            work setups from shutting down when connected to the grid, with USB
            HID support for shutdown signaling.
          </li>
          <li>
            <strong>Quiet operation:</strong> The redesigned thermal system runs
            at around 25dB under normal loads. In a tight camper van where you
            sleep close to your gear, the silent fans are a huge upgrade over
            older, louder models.
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Considerations</SlugHeading>
        <ul>
          <li>
            <strong>Low solar voltage limit:</strong> Restricted to 11-60V⎓18A
            per port. It's essential to plan out your solar array's open-circuit
            voltage, as multi-panel series strings can easily exceed the 60V
            ceiling. Keep in mind that cold weather increases voltage, which can
            push a borderline setup over the edge into an over-voltage shutdown
            or even damage the unit.
          </li>
          <li>
            <strong>Shared expansion port constraint:</strong> The rear
            expansion port is shared between extra batteries and the EcoFlow
            Alternator Charger. To use an expansion battery and charge from your
            vehicle simultaneously, you must purchase the{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ecoflow-extra-battery-expansion-adapter?variant=55507615645769"
            >
              Extra Battery Expansion Adapter
            </Link>
            . Otherwise, you are forced to use a basic XT60 cable, which slows
            down charging speeds and disables reverse-charging features.
          </li>
          <li>
            <strong>Shared DC output limits:</strong> The high-output 30A
            Anderson port shares its overall power pool with the cigarette
            lighter and USB ports, meaning they cannot all be maxed out
            simultaneously.
          </li>
          <li>
            <strong>Rear-facing DC button:</strong> Placing this button on the
            back makes physical access difficult for some installs, leaving you
            dependent on the app to toggle DC power.
          </li>
          <li>
            <strong>No control screen accessory:</strong> The lack of an
            external display accessory is a drawback for built-in setups,
            whereas the premium DELTA Pro series supports a dedicated control
            display. While a phone app is great for changing settings, it cannot
            replace the convenience of physical buttons and glanceable power
            info when your hands are full or the unit is tucked away out of
            sight.
          </li>
          <li>
            <strong>Cold weather use:</strong> Like most power stations, it
            doesn't include internal self‑heating, so use can be restricted if
            internal temperatures drop below 32°F.
          </li>
          <li>
            <strong>No EV station charging:</strong> Unlike the DELTA Pro
            series, this model lacks the accessory to recharge at public EV
            stations. If heavy cloud cover or alternator charging issues leave
            you stranded with low capacity, you lose a quick, reliable way to
            rescue your trip.
          </li>
        </ul>

        <AffiliateAd brand="EcoFlow" size="billboard" />
      </Center>
      <Center>
        <SlugHeading tag="h2">Detailed Comparison</SlugHeading>
        <p>
          A side‑by‑side comparison with the most similar EcoFlow alternatives
          to the DELTA 3 Max Plus:
        </p>
        <FixedTable>
          <table>
            <thead>
              <tr>
                <th class={editorialStyle.sticky}>Model</th>
                <th>DELTA 3 Max Plus</th>
                <th>DELTA 3 Max</th>
                <th>DELTA 3 Ultra Plus</th>
                <th>DELTA Pro 3</th>
              </tr>
              <tr style="font-style:italic;">
                <th class={editorialStyle.sticky}>AKA</th>
                <th>D3M+</th>
                <th>D3M</th>
                <th>D3U+</th>
                <th>DP3</th>
              </tr>
            </thead>
            <tbody>
              <tr class={editorialStyle.noHover}>
                <th class={editorialStyle.sticky}>
                  <strong>Photo</strong>
                </th>
                <td>
                  <Image
                    src="/images/products/ecoflow/delta-3-max-plus/front-right.webp"
                    alt="EcoFlow DELTA 3 Max Plus"
                    showAlt
                    maxHeight={100}
                  />
                </td>
                <td>
                  <Image
                    src="/images/products/ecoflow/delta-3-max/front-right.webp"
                    alt="EcoFlow DELTA 3 Max"
                    showAlt
                    maxHeight={100}
                  />
                </td>
                <td>
                  <Image
                    src="/images/products/ecoflow/delta-3-ultra-plus/front-right.webp"
                    alt="EcoFlow DELTA 3 Ultra Plus"
                    showAlt
                    maxHeight={100}
                  />
                </td>
                <td>
                  <Image
                    src="/images/products/ecoflow/delta-pro-3/front-right.webp"
                    alt="EcoFlow DELTA Pro 3"
                    showAlt
                    maxHeight={100}
                  />
                </td>
              </tr>
              <tr class={editorialStyle.noHover}>
                <th class={editorialStyle.sticky}>
                  <strong>Links</strong>
                </th>
                <td>
                  <ButtonBar>
                    <Button
                      size="small"
                      {...productLinkData.delta3MaxPlus}
                      icon="EcoFlow"
                    >
                      Store
                    </Button>
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/us/product/delta-3-max-plus?lang=en_US"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
                <td>
                  <ButtonBar>
                    <Button
                      size="small"
                      {...productLinkData.delta3Max}
                      icon="EcoFlow"
                    >
                      Store
                    </Button>
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/us/product/delta-3-max?lang=en_US"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
                <td>
                  <ButtonBar>
                    <Button
                      size="small"
                      {...productLinkData.delta3UltraPlus}
                      icon="EcoFlow"
                    >
                      Store
                    </Button>
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/cn/product/delta-3-ultra-plus?lang=en_US"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
                <td>
                  <ButtonBar>
                    <Button
                      size="small"
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105"
                      icon="EcoFlow"
                    >
                      Store
                    </Button>
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/us/product/delta-pro-3-portable-power-station?lang=en_US"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Price</strong>
                </th>
                <td>
                  <NoWrap>
                    $1,099 <s>$1,899</s>
                  </NoWrap>
                </td>
                <td>
                  <NoWrap>
                    $799 <s>$1,499</s>
                  </NoWrap>
                </td>
                <td>
                  <NoWrap>
                    $1,499 <s>$2,899</s>
                  </NoWrap>
                </td>
                <td>
                  <NoWrap>
                    $2,599 <s>$3,699</s>
                  </NoWrap>
                </td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>Capacity</strong>
                </th>
                <td>2,048Wh</td>
                <td>2,048Wh</td>
                <td>3,072Wh</td>
                <td>4,096Wh</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Extra battery</strong>
                </th>
                <td>
                  2x <sup>1</sup>
                </td>
                <td>--</td>
                <td>
                  2x <sup>1</sup>
                </td>
                <td>2x</td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>AC output</strong>
                </th>
                <td>
                  3,000W total <br />
                  6,000W surge
                </td>
                <td>
                  2,400W total <br />
                  4,800W surge
                </td>
                <td>
                  3,600W total <br />
                  7,200W surge
                </td>
                <td>
                  4,000W total <br />
                  8,000W surge
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>AC ports</strong>
                </th>
                <td>x4 (20A each)</td>
                <td>x4 (20A each)</td>
                <td>
                  ×4 (20A each)
                  <br />
                  x1 (30A)
                </td>
                <td>
                  ×4 (20A each)
                  <br />
                  x1 (30A)
                  <br />
                  x1 (120/240V~16.7A)
                  <br />
                  x1 (240V~16.7A)
                </td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>DC output</strong>
                </th>
                <td>12.6V⎓30A, 378W</td>
                <td>12.6V⎓10A, 126W</td>
                <td>12.6V⎓30A, 378W</td>
                <td>12.6V⎓30A, 378W</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Anderson</strong>
                </th>
                <td>30A, 378W</td>
                <td>--</td>
                <td>30A, 378W</td>
                <td>30A, 378W</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>
                    <NoWrap>
                      Cigarette port <sup>2</sup>
                    </NoWrap>
                  </strong>
                </th>
                <td>12.6V⎓10A, 126W</td>
                <td>12.6V⎓10A, 126W</td>
                <td>12.6V⎓10A, 126W</td>
                <td>--</td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>Solar input 1</strong>
                </th>
                <td>
                  11-60V⎓18A
                  <br />
                  500W
                </td>
                <td>
                  11-60V⎓18A
                  <br />
                  500W
                </td>
                <td>
                  11-60V⎓18A
                  <br />
                  800W
                </td>
                <td>
                  30-150V⎓15A
                  <br />
                  1,600W
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Solar input 2</strong>
                </th>
                <td>
                  11V-60V⎓18A
                  <br />
                  500W
                </td>
                <td>--</td>
                <td>
                  11-60V⎓18A
                  <br />
                  800W
                </td>
                <td>
                  11V-60V⎓20A
                  <br />
                  1,000W
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Alternator input</strong>
                </th>
                <td>100-1,000W</td>
                <td>100-500W</td>
                <td>100-1,000W</td>
                <td>100-2,000W</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>AC input</strong>
                </th>
                <td>15A 1,800W</td>
                <td>15A 1,800W</td>
                <td>15A 1,800W</td>
                <td>15A 1,800W</td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>USB A</strong>
                </th>
                <td>1x</td>
                <td>1x</td>
                <td>1x</td>
                <td>2x</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>USB C</strong>
                </th>
                <td>3x</td>
                <td>3x</td>
                <td>3x</td>
                <td>2x</td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>Size (in)</strong>
                </th>
                <td>19.4 × 9.5 × 12</td>
                <td>19.4 × 9.4 × 12</td>
                <td>24.1 × 12.9 × 15.6</td>
                <td>27.3 × 16.2 × 13.4</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Size (mm)</strong>
                </th>
                <td>
                  <NoWrap>494 × 242 × 305</NoWrap>
                </td>
                <td>
                  <NoWrap>494 × 239 × 305</NoWrap>
                </td>
                <td>
                  <NoWrap>613.1 × 327.7 × 395</NoWrap>
                </td>
                <td>
                  <NoWrap>693 × 410.4 × 341</NoWrap>
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Weight (lbs)</strong>
                </th>
                <td>48.7</td>
                <td>44.8</td>
                <td>74.3</td>
                <td>113.5</td>
              </tr>
            </tbody>
          </table>
        </FixedTable>
        <div>
          <p class="caption">
            <strong>1.</strong> Using the EcoFlow Extra Battery Expansion
            Adapter. <strong>2.</strong> DC output of cigarette port is included
            in the total overall DC output, not an independent value.
          </p>
        </div>

        <SlugHeading tag="h2">Full Specifications</SlugHeading>
        <Accordion
          headingsAs="h3"
          items={[
            {
              heading: "General",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Model:</strong> EF-DL3-MP
                    </li>
                    <li>
                      <strong>Net Weight:</strong> 48.7 lbs (22.1 kg)
                    </li>
                    <li>
                      <strong>Dimensions:</strong> 19.4 × 9.5 × 12.0 in (494 ×
                      242 × 305 mm)
                    </li>
                    <li>
                      <strong>EMC:</strong> Class B
                    </li>
                    <li>
                      <strong>Warranty period:</strong> 5 years (3-year standard
                      warranty and 2-year extended warranty available upon
                      EcoFlow App registration)
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "AC Power",
              content: (
                <Fragment>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      AC Output:
                      <ul>
                        <li>
                          <strong>Waveform:</strong> Pure sine wave
                        </li>
                        <li>
                          <strong>Socket Type (US):</strong>
                          <ul class="none">
                            <li>
                              Low-voltage / Single phase:
                              <ul class="circle">
                                <li>4× NEMA 5-20R, 120V~20A</li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Output Details (US):</strong>{" "}
                          <ul class="none">
                            <li>
                              Discharge Only:
                              <ul class="circle">
                                <li>120V~60Hz 3000W total (surge 6000W)</li>
                              </ul>
                            </li>
                            <li>
                              Bypass Mode:
                              <ul class="circle">
                                <li>100-120V~50/60Hz 3000W total</li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <hr />
                    </li>
                    <li>
                      AC Input:
                      <ul>
                        <li>
                          <strong>Input Details (US):</strong>
                          <ul class="circle">
                            <li>Charge Only: 100-120V~15A 50/60Hz</li>
                            <li>Bypass Mode: 100-120V~15A 50/60Hz</li>
                          </ul>
                        </li>
                        <li>
                          <strong>UPS:</strong> Switching time ≤10ms
                        </li>
                      </ul>
                      <hr />
                    </li>
                  </ul>
                  <p class="caption">
                    See{" "}
                    <Link
                      external
                      href="https://manuals.ecoflow.com/us/product/delta-3-max-plus?lang=en_US"
                    >
                      product manual
                    </Link>{" "}
                    for other countries.
                  </p>
                </Fragment>
              ),
            },
            {
              heading: "DC Power",
              content: (
                <Fragment>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      DC Output:
                      <ul>
                        <li>
                          <strong>USB Output:</strong>
                          <ul class="circle">
                            <li>1 ×USB-A: 5V⎓3A / 9V⎓2A / 12V⎓1.5A, 18W Max</li>
                            <li>
                              1 ×USB-C: 5V⎓3A / 9V⎓3A / 12V⎓3A / 15V⎓3A / 20V⎓5A
                              / 28V⎓5A, 140W Max
                            </li>
                            <li>
                              2 ×USB-C: 5V⎓3A / 9V⎓3A / 12V⎓3A / 15V⎓3A /
                              20V⎓2.25A, 45W Max per port, total 45W
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>12V DC Output:</strong> 12.6V⎓30A, 378W total
                          <ul class="circle">
                            <li>
                              Anderson Powerpole port: 12.6V⎓30A, 378W MAX
                            </li>
                            <li>Cigarette Lighter Port: 12.6V⎓10A, 126W MAX</li>
                          </ul>
                        </li>
                        <li>
                          <strong>Battery output port:</strong> 43.2V-57.6V⎓46A
                          Max
                        </li>
                      </ul>
                      <hr />
                    </li>
                    <li>
                      DC / Solar Input:
                      <ul>
                        <li>
                          <strong>PV 1:</strong> XT60 Port
                          <ul class="none">
                            <li>
                              Solar / Alternator Charger Input: 11-60V⎓18A Max,
                              500W Max
                            </li>
                            <li>
                              DC / Car Input: 12V⎓8A Max, 24V⎓8A Max, 48V⎓10.4A
                              Max
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>PV 2:</strong> XT60 Port
                          <ul class="none">
                            <li>Solar Input: 11V-60V⎓18A Max, 500W Max</li>
                            <li>
                              DC / Car Input: 12V⎓8A Max, 24V⎓8A Max, 48V⎓10.4A
                              Max
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Battery input port:</strong> 43.2V-57.6V⎓93A
                          Max
                        </li>
                      </ul>
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Battery",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Rated Capacity:</strong> 2048Wh 51.2V⎓40Ah
                    </li>
                    <li>
                      <strong>Battery Chemistry:</strong> LFP (LiFePO4)
                    </li>
                    <li>
                      <strong>Cycle life:</strong> Battery maintains 80%+ SoH
                      (State of Health) after 4000 cycles
                    </li>
                    <li>
                      <strong>Protection Type:</strong> Over Voltage Protection,
                      Overload Protection, Over Temperature Protection, Short
                      Circuit Protection, Low Temperature Protection, Low
                      Voltage Protection, Overcurrent Protection
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Environmental Temperature",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Optimal Operating Temperature:</strong> 68° to
                      86°F
                    </li>
                    <li>
                      <strong>Discharge Temperature:</strong> 14° to 113°F
                    </li>
                    <li>
                      <strong>Charge Temperature:</strong> 32° to 113°F
                    </li>
                    <li>
                      <strong>Storage Temperature:</strong> 14° to 113°F
                      (optimal: 68°F to 86°F)
                    </li>
                    <li>
                      <strong>Operating Altitude:</strong> &lt; 3,000 m (9,843
                      ft)
                    </li>
                    <li>
                      <strong>Ingress protection rating:</strong> IP20
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Communications",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Wi-Fi (2.4G):</strong> Frequency: 2412 MHz - 2472
                      MHz (20M)/2422-2462 MHz (40M), Maximum Output Power: ≤ 20
                      dBm
                    </li>
                    <li>
                      <strong>Bluetooth:</strong> Frequency: 2402 MHz - 2480
                      MHz, Maximum Output Power: ≤ 20 dBm
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">DELTA 3 Max Series Comparison</SlugHeading>
        <p>
          EcoFlow <strong>DELTA 3 Max Plus</strong> vs.{" "}
          <strong>DELTA 3 Max</strong> (base): Which is Right for You?
        </p>

        <ImageSet
          size={4}
          border={true}
          showAlt
          images={[
            {
              lg: "/images/products/ecoflow/delta-3-max-plus/front-right.webp",
              alt: "DELTA 3 Max Plus (front)",
            },
            {
              lg: "/images/products/ecoflow/delta-3-max/front-right.webp",
              alt: "DELTA 3 Max (front)",
            },
            {
              lg: "/images/products/ecoflow/delta-3-max-plus/back.webp",
              alt: "DELTA 3 Max Plus (back)",
            },
            {
              lg: "/images/products/ecoflow/delta-3-max/back.webp",
              alt: "DELTA 3 Max (back)",
            },
          ]}
        />

        <p>
          Both units share the exact same 2,048Wh base capacity, but the DELTA 3
          Max (Non-Plus) is a streamlined version that cuts out several advanced
          features to offer a much lower price point. If you are trying to
          decide whether to save a few hundred dollars on the base model, here
          is what you give up:
        </p>
        <ul>
          <li>
            <strong>Smaller inverter:</strong> The base model drops down to a
            2,400W continuous output (4,800W surge) compared to the Plus model's
            larger 3,000W continuous output (6,000W surge).
          </li>
          <li>
            <strong>Single solar input port:</strong> The base DELTA 3 Max cuts
            your solar capability in half. It only offers a single 500W solar
            port, whereas the Plus model gives you dual independent 500W ports
            (1,000W total).
          </li>
          <li>
            <strong>No expansion battery port:</strong> The base DELTA 3 Max
            lacks an expansion battery port. Its capacity is capped at 2,048Wh,
            whereas the Plus can expand up to 10kWh and support advanced EcoFlow
            alternator charger features.
          </li>
          <li>
            <strong>No high-amp DC output:</strong> The base model completely
            lacks the 30A Anderson port. You are limited to a standard 10A
            cigarette lighter socket, making it much harder to run heavy 12V van
            components like a diesel heater or fuse block.
          </li>
          <li>
            <strong>Lower speed USB-C:</strong> While both models have the same
            number of physical USB ports, the base unit replaces the high-speed
            140W USB-C port with a 100W port and drops the two auxiliary USB-C
            ports from 45W down to 30W.
          </li>
          <li>
            <strong>Alternator charging limits:</strong> The base DELTA 3 Max
            caps alternator input at 500W (vs. 1,000W on the Plus), and because
            it lacks a dedicated expansion/alternator port, using an alternator
            charger consumes the only rear DC input port. This prevents you from
            using solar at the same time and forces you to choose one charging
            source while driving.
          </li>
          <li>
            <strong>No independently switched AC groups:</strong> The base model
            treats all of its AC outlets as a single group, turning them all on
            or off together. The Plus model splits its outlets into two
            independently controlled zones (AC1 and AC2). Coupled with the app's
            Smart Output Priority, Plus users can automatically drop
            non-essential loads (like lights) while keeping critical appliances
            (like a medical device) running smoothly when the battery drops
            below a preset threshold.
          </li>
          <li>
            <strong>No UPS HID signaling:</strong> The base model lacks
            HID‑compatible UPS signaling, so it cannot send safe‑shutdown
            commands to computers or other devices during outages or low‑battery
            events.
          </li>
          <li>
            <strong>No smart generator integration:</strong> The base unit lacks
            the EcoFlow generator start and stop features and cannot accept the
            high speed 2,600W generator input that lets the Plus model charge to
            80% in just 43 minutes.
          </li>
        </ul>
        <p>
          The base <strong>DELTA 3 Max</strong> is an incredible budget friendly
          alternative if you don’t need a permanent, expandable van electrical
          system. If you just need a standalone power station to run basic
          appliances like a portable fridge and laptop during weekend camping
          trips or home blackouts, saving money on the base model can be a great
          option for some people.
        </p>

        <LargeViewOnly>
          <ButtonDualGroup small>
            <ButtonGroup title="DELTA 3 Max (base)">
              <ButtonList size="medium">
                <Button
                  size="medium"
                  {...productLinkData.delta3Max}
                  icon="EcoFlow"
                >
                  View on EcoFlow
                </Button>
                <Button
                  size="medium"
                  affiliate="https://amzn.to/3Qe0uW3"
                  href="https://www.amazon.com/dp/B0FQV6LMVX/"
                  secondary
                  icon="Amazon"
                >
                  View on Amazon
                </Button>
              </ButtonList>
            </ButtonGroup>
            <ButtonGroup title="DELTA 3 Max Plus">
              <ButtonList size="medium">
                <Button
                  size="medium"
                  {...productLinkData.delta3MaxPlus}
                  icon="EcoFlow"
                >
                  View on EcoFlow
                </Button>
                <Button
                  size="medium"
                  affiliate="https://amzn.to/4qhlyYI"
                  href="https://www.amazon.com/dp/B0FQV9Q9J2/"
                  secondary
                  icon="Amazon"
                >
                  View on Amazon
                </Button>
              </ButtonList>
            </ButtonGroup>
          </ButtonDualGroup>
        </LargeViewOnly>

        {/* <ButtonList>
          <Button
            {...productLinkData.delta3MaxPlus}
            icon="EcoFlow"
          >
            DELTA 3 Max Plus
          </Button>
          <Button
            {...productLinkData.delta3Max}
            icon="EcoFlow"
          >
            DELTA 3 Max
          </Button>
        </ButtonList> */}
      </Center>

      <Center>
        <SlugHeading tag="h2">Accessories</SlugHeading>

        <SlugHeading tag="h3">DC Fuse Panel</SlugHeading>
        <p>
          Learn how to safely connect 12V accessories (fridge, heater, lights,
          etc.) to your EcoFlow using a DC fuse block:
        </p>
        <ReviewItem href={namedRoutes.ecoflow.wiring12v} />
        <Accordion
          right
          items={[
            {
              preview: (
                <AccordionPreview
                  headingAs="h4"
                  prefix="Fuse block"
                  heading="Blue Sea Systems 5026 Fuse Block"
                  src="/images/products/blue-sea-systems/5026.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    There is also a 6 circuit model available (
                    <Link
                      affiliate="https://amzn.to/43tntjR"
                      href="https://www.amazon.com/dp/B000THQ0CQ"
                    >
                      5025
                    </Link>
                    ), but currently costs more and it's nice to have room to
                    add extra circuits in the future.
                  </p>
                  <p>
                    <strong>Model:</strong> 5026
                    <br />
                    <strong>Circuits:</strong> 12
                    <br />
                    <strong>Max Amperage:</strong> 30A per circuit (100A total)
                    <br />
                    <strong>Max Voltage:</strong> 32V DC
                    <br />
                    <strong>Fuse Type:</strong> ATO® or ATC®
                  </p>
                  <p>
                    You will also need to purchase the appropriate fuses to
                    match the wiring of your circuits. These can be purchased{" "}
                    <Link
                      affiliate="https://amzn.to/4oLUFvA"
                      href="https://www.amazon.com/dp/B00FLZRJJO"
                    >
                      individually
                    </Link>{" "}
                    or in a{" "}
                    <Link
                      affiliate="https://amzn.to/4r0jiGd"
                      href="https://www.amazon.com/dp/B00CQ8ILFA"
                    >
                      multi-pack
                    </Link>
                    . Be sure to use a reputable brand as these are used to
                    prevent an electrical fire.
                  </p>
                  <ButtonList>
                    <Button
                      affiliate="https://amzn.to/4qXtEXd"
                      href="https://www.amazon.com/dp/B001P6FTHC"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
            {
              preview: (
                <AccordionPreview
                  headingAs="h4"
                  prefix="Anderson to ring terminal"
                  heading="10AWG 45A"
                  src="/images/products/paekq-10awg-anderson-ring.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    Allows you to safely connect a DC fuse block to your power
                    station's Anderson Powerpole port.
                  </p>
                  <p>
                    <strong>Length:</strong> 25in
                    <br />
                    <strong>Gauge:</strong> 10AWG
                    <br />
                    <strong>Max Amperage:</strong> 45A (comes with 30A fuse)
                    <br />
                    <strong>Fuse Type:</strong> ATC®
                  </p>
                  <ButtonList>
                    <Button
                      affiliate="https://amzn.to/3JCH7TQ"
                      href="https://www.amazon.com/dp/B0B2P5JDX7"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
          ]}
        />
        <br />

        <SlugHeading tag="h3">Alternator Chargers</SlugHeading>
        <p>
          More reliable than solar, these units pull power from your vehicle to
          quickly charge your power station as you drive.
        </p>
        <ul class="none">
          <li>
            <ReviewItem
              href={namedRoutes.ecoflow.altCharger.quick}
              description="500W & 800W Models"
            />
          </li>
          <li>
            <ReviewItem href={namedRoutes.alternatorChargers} />
          </li>
        </ul>
        <br />

        <SlugHeading tag="h3">Solar Panels</SlugHeading>
        <p>
          EcoFlow offers both{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/collections/mountable-solar-panels"
          >
            mountable
          </Link>{" "}
          and{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/collections/portable-solar-panels"
          >
            portable
          </Link>{" "}
          solar panels, some of which are rigid, flexible, traditional, or
          bifacial. While EcoFlow provides various solar panel options and
          bundles, always prioritize panels that physically fit your vehicle;
          using other reputable brands is perfectly fine.
        </p>
        <br />

        <SlugHeading tag="h3">Extra Batteries</SlugHeading>
        <p>
          Supports the following extra batteries. Some of EcoFlow's alternator
          chargers use the same port which can limit you to a single extra
          battery. See full{" "}
          <Link
            href={`${namedRoutes.ecoflow.batteryCompatibility}?system=DELTA+3+Max+Plus`}
          >
            battery compatibility details
          </Link>
          .
        </p>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-3-max-plus-smart-extra-battery?variant=55069632790601"
              img="/images/products/ecoflow/delta-3-max-plus-smart-extra-battery/front-right.webp"
              title="DELTA 3 Max Plus Smart Extra Battery"
              description={<Fragment>2048Wh extra battery</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-3-extra-battery?variant=41385808199753"
              img="/images/products/ecoflow/delta-pro-3-smart-extra-battery/front-right.webp?v=2"
              title="DELTA Pro 3 Smart Extra Battery"
              description={<Fragment>4096Wh extra battery</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-3-series-smart-extra-battery?variant=41631849971785"
              img="/images/products/ecoflow/delta-3-series-smart-extra-battery/front-right.webp"
              title="DELTA 3 Series Smart Extra Battery"
              description={<Fragment>1024Wh extra battery</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-2-max-smart-extra-battery?variant=40954813448265"
              img="/images/products/ecoflow/delta-2-max-smart-extra-battery/front-right.webp"
              title="DELTA 2 Max Smart Extra Battery"
              description={<Fragment>2048Wh extra battery</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
        </ul>
        <br />

        <SlugHeading tag="h3">Other Accessories</SlugHeading>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ecoflow-extra-battery-expansion-adapter?variant=55507615645769"
              img="/images/products/ecoflow/accessories/extra-battery-expansion-adapter.webp"
              title="Extra Battery Expansion Adapter"
              description={
                <Fragment>
                  Connects an alternator charger and extra battery for the DELTA
                  3 Max Plus and Ultra Plus
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
        </ul>
        <Accordion
          items={[
            {
              heading: "View More",
              content: (
                <Fragment>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/collections/delta-3-series-accessories/products/solar-charging-cable?variant=39880496382025"
                        img="/images/products/ecoflow/accessories/solar-to-xt60-xt60i-charging-cable.webp"
                        title="Solar to XT60/XT60i Charging Cable"
                        description={
                          <Fragment>Charge from solar panels</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/solar-extension-cable?_pos=1&_sid=e350c6fc3&_ss=r&variant=31865877823561"
                        img="/images/products/ecoflow/accessories/solar-extension-cable.webp"
                        title="Solar Extension Cable"
                        description={
                          <Fragment>Provides additional cable length</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/solar-parallel-connection-cable?variant=31289813729353"
                        img="/images/products/ecoflow/accessories/solar-parallel-connection-cable.webp"
                        title="Solar Parallel Connection Cable"
                        description={
                          <Fragment>Connects solar panels in parallel</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393"
                        img="/images/products/ecoflow/accessories/smart-generator-adapter.webp"
                        title="Smart Generator Adapter"
                        description={
                          <Fragment>
                            For use with Alternator Charger or Smart Generator
                            (XT150 cables)
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/car-charging-cable?variant=39308519604297"
                        img="/images/products/ecoflow/accessories/car-charging-cable.webp"
                        title="Car Charging Cable"
                        description={
                          <Fragment>
                            Charge from your vehicle's cigarette lighter socket
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/collections/rv-ev-power-accessories/products/portable-power-station-grounding-adapter?variant=39987909984329"
                        img="/images/products/ecoflow/accessories/portable-power-station-grounding-adapter.webp"
                        title="Portable Power Station Grounding Adapter"
                        description={
                          <Fragment>
                            Neutral-ground bonding prevents floating ground
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h3">Suggestions to EcoFlow</SlugHeading>
        <p>A few things I would like to see improved on the next version:</p>
        <ul>
          <li>
            <strong>Dual expansion ports:</strong> Provide two native extra
            battery ports on the unit so users aren't forced to buy a costly{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ecoflow-extra-battery-expansion-adapter?variant=55507615645769"
            >
              expansion adapter
            </Link>{" "}
            to use multiple batteries or run the alternator charger
            simultaneously.
          </li>
          <li>
            <strong>Increased solar input:</strong> Instead of providing two
            500W ports, have one 500W port and a higher throughput 800W port.
            This increased input would be especially useful for larger solar
            arrays and when paired with the larger capacity{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/collections/delta-pro-series-accessories/products/delta-pro-3-extra-battery"
            >
              DELTA Pro 3 Smart Extra Battery
            </Link>
            .
          </li>
          <li>
            <strong>Control screen accessory:</strong> Support an external
            control screen accessory with physical buttons like the DELTA Pro
            series does. This is very useful for vanlife builds where the power
            station might be located in an out-of-reach location.
          </li>
          <li>
            <strong>More USB ports:</strong> So many modern devices use USB, and
            a lot of gear still relies on older USB-A cables. I think the front
            panel should be expanded to contain at least two high-output 140W
            USB-C ports, two standard USB-C ports, and two USB-A ports.
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">My Verdict</SlugHeading>
        <p>
          The <strong>EcoFlow DELTA 3 Max Plus</strong> delivers an impressive
          balance of high-tier power and compact portability. By packing a
          3,000W inverter and native 30A DC output into a manageable
          sub-50-pound chassis, it eliminates the need to choose between a
          home-backup giant and a lower-output mid-sized station. If you want a
          robust, high-output electrical setup for your van or mobile build
          without sacrificing precious garage space or breaking your budget, the
          DELTA 3 Max Plus is a top option to consider.
        </p>

        <EcoFlowCouponCode
          href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station"
          buttonText="Buy from EcoFlow"
        />

        <p>
          Not sure it’s the best fit? My{" "}
          <Link href={namedRoutes.powerSystems}>power systems guide</Link>{" "}
          covers all the popular brands.
        </p>

        <ButtonDualGroup>
          <ButtonGroup title="DELTA 3 Max Plus">
            <ButtonList>
              <Button {...productLinkData.delta3MaxPlus} icon="EcoFlow">
                Buy from EcoFlow
              </Button>
              <Button
                affiliate="https://amzn.to/4qhlyYI"
                href="https://www.amazon.com/dp/B0FQV9Q9J2/"
                secondary
                icon="Amazon"
              >
                Buy on Amazon
              </Button>
            </ButtonList>
          </ButtonGroup>
          <ButtonGroup title="DELTA 3 Max (base)">
            <ButtonList size="medium">
              <Button
                size="medium"
                {...productLinkData.delta3Max}
                icon="EcoFlow"
              >
                Buy from EcoFlow
              </Button>
              <Button
                size="medium"
                affiliate="https://amzn.to/3Qe0uW3"
                href="https://www.amazon.com/dp/B0FQV6LMVX/"
                secondary
                icon="Amazon"
              >
                Buy on Amazon
              </Button>
            </ButtonList>
          </ButtonGroup>
        </ButtonDualGroup>

        <Tags tags={headerInfo.tags} brands={headerInfo.brands} />
      </Center>
      <Center>
        <h3>Related</h3>
        <ul class="none">
          <li>
            <ReviewItem href={namedRoutes.ecoflow.vanlife} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.d3ultraPlus} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.dp3} />
          </li>

          <li>
            <ReviewItem href={namedRoutes.inventory.vanlife} />
          </li>
        </ul>
      </Center>
      <Questions />
      <Center>
        <Author
          author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />
      </Center>
      <StickyButtons
        title="EcoFlow DELTA 3 Max Plus"
        description={
          <Fragment>
            $1,099 <s>$1,899</s> | 2,048Wh
          </Fragment>
        }
      >
        <Button {...productLinkData.delta3MaxPlus} icon="EcoFlow">
          View on EcoFlow
        </Button>
        <Button
          affiliate="https://amzn.to/4qhlyYI"
          href="https://www.amazon.com/dp/B0FQV9Q9J2/"
          secondary
          icon="Amazon"
        >
          View on Amazon
        </Button>
      </StickyButtons>
    </Editorial>
  </div>
);

export default Page;
